<div class="modal-header">
  <div class="modal-title d-flex gap-2">
    <div>
      <ng-container i18n>Property ID</ng-container> ({{ connection.propertyId }}) -
      {{ connection.roomName || connection.propertyName }} ({{ connection.roomId }})
    </div>
    <app-page-help articleId="-" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<mat-stepper [linear]="true" class="m-3" #stepper>
  <mat-step
    label="Connecting"
    [state]="stepper.selectedIndex > 0 ? 'done' : 'number'"
    [completed]="isConnectingStepDone || stepper.selectedIndex > 0"
  >
    <app-airbnb-listing-wizard-step1
      (next)="onRatesStep()"
      (coHost)="stepper.next()"
      [channel]="channel"
      [connection]="connection"
    ></app-airbnb-listing-wizard-step1>
  </mat-step>
  <mat-step
    label="Rates"
    [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
    [completed]="isRatesStepDone || stepper.selectedIndex > 1"
    #rates
  >
    <app-airbnb-listing-wizard-step3
      (prev)="stepper.previous()"
      (next)="stepper.next()"
      [connection]="connection"
      [channel]="channel"
      [isActive]="stepper.selectedIndex === 1"
      #step2
    ></app-airbnb-listing-wizard-step3>
  </mat-step>
  <mat-step label="Review" [state]="stepper.selectedIndex > 2 ? 'done' : 'number'">
    <app-airbnb-listing-wizard-step4 (prev)="stepper.previous()" (done)="close()"></app-airbnb-listing-wizard-step4>
  </mat-step>
  <ng-template matStepperIcon="done">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
</mat-stepper>
